import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseFacade } from './application/warehouse.facade';
import { WarehouseDataService } from './infrastructure/warehouses/warehouse.data.service';
import { WarehouseStore } from './infrastructure/warehouses/warehouse.store';
import { WarehouseMapper } from './infrastructure/warehouses/warehouse.mapper';
import { sharedEnv } from '@pf/shared-common';
import {
    ApiModule as WmsApiModule,
    Configuration as WmsApiConfig,
    ConfigurationParameters,
} from '@control-tower/platform-wms';
import { ZoneFacade } from './application/zone.facade';
import { ZoneDataService } from './infrastructure/zones/zone.data.service';
import { ZoneStore } from './infrastructure/zones/zone.store';
import { ZoneMapper } from './infrastructure/zones/zone.mapper';
import { SlotFacade } from './application/slot.facade';
import { SlotDataService } from './infrastructure/slots/slot.data.service';
import { SlotStore } from './infrastructure/slots/slot.store';
import { SlotMapper } from './infrastructure/slots/slot.mapper';
import { ZoneSlotService } from './application/zone-slot.service';
import { ContainerFacade } from './application/container.facade';
import { ContainerDataService } from './infrastructure/containers/container.data.service';
import { ContainerStore } from './infrastructure/containers/container.store';
import { ContainerMapper } from './infrastructure/containers/container.mapper';
import { HandlingUnitsFacade } from './application/handling-units.facade';
import { PickListFacade } from './application/pick-list.facade';
import { PickListDataService } from './infrastructure/pick-lists/pick-list.data.service';
import { PickListStore } from './infrastructure/pick-lists/pick-list.store';
import { PickListMapper } from './infrastructure/pick-lists/pick-list.mapper';
import { PickFacade } from './application/pick.facade';
import { PickDataService } from './infrastructure/picks/pick.data.service';
import { PickStore } from './infrastructure/picks/pick.store';
import { PickMapper } from './infrastructure/picks/pick.mapper';
import { ProjectFacade } from './application/project.facade';
import { ProjectDataService } from './infrastructure/projects/project.data.service';
import { ProjectStore } from './infrastructure/projects/project.store';
import { ProjectMapper } from './infrastructure/projects/project.mapper';
import { ProjectLineItemFacade } from './application/project-line-item.facade';
import { ProjectLineItemDataService } from './infrastructure/project-line-items/project-line-item.data.service';
import { ProjectLineItemStore } from './infrastructure/project-line-items/project-line-item.store';
import { ProjectLineItemMapper } from './infrastructure/project-line-items/project-line-item.mapper';
import { InventoryBundleFacade } from './application/inventory-bundle.facade';
import { InventoryBundleDataService } from './infrastructure/inventory-bundles/inventory-bundle.data.service';
import { InventoryBundleStore } from './infrastructure/inventory-bundles/inventory-bundle.store';
import { InventoryBundleMapper } from './infrastructure/inventory-bundles/inventory-bundle.mapper';
import { ExceptionFacade } from './application/exception.facade';
import { ExceptionDataService } from './infrastructure/exceptions/exception.data.service';
import { ExceptionStore } from './infrastructure/exceptions/exception.store';
import { ExceptionMapper } from './infrastructure/exceptions/exception.mapper';
import { ExceptionTypeFacade } from './application/type-entities/ExceptionTypeFacade';
import { ExceptionCauseTypeFacade } from './application/type-entities/ExceptionCauseTypeFacade';
import { ResolutionTypeFacade } from './application/type-entities/ResolutionTypeFacade';
import { ExceptionDocumentsFacade } from './application/exception-documents.facade';
import { WarehouseStructureService } from './infrastructure/warehouses/warehouse-structure.service';
import { InventoryAdjustmentFacade } from './application/inventory-adjustment.facade';
import { InventoryAdjustmentDataService } from './infrastructure/inventory-adjustments/inventory-adjustment.data.service';
import { InventoryAdjustmentStore } from './infrastructure/inventory-adjustments/inventory-adjustment.store';
import { InventoryAdjustmentMapper } from './infrastructure/inventory-adjustments/inventory-adjustment.mapper';
import { ReplenishmentFacade } from './application/replenishment.facade';
import { ReplenishmentDataService } from './infrastructure/replenishments/replenishment.data.service';
import { ReplenishmentStore } from './infrastructure/replenishments/replenishment.store';
import { ReplenishmentMapper } from './infrastructure/replenishments/replenishment.mapper';
import { ContainerTypeFacade } from './application/type-entities/ContainerTypeFacade';
import { EquipmentTypeFacade } from './application/equipment-type.facade';
import { EquipmentTypeDataService } from './infrastructure/equipment-types/equipment-type.data.service';
import { EquipmentTypeStore } from './infrastructure/equipment-types/equipment-type.store';
import { EquipmentTypeMapper } from './infrastructure/equipment-types/equipment-type.mapper';
import { EquipmentFacade } from './application/equipment.facade';
import { EquipmentDataService } from './infrastructure/equipments/equipment.data.service';
import { EquipmentStore } from './infrastructure/equipments/equipment.store';
import { EquipmentMapper } from './infrastructure/equipments/equipment.mapper';
import AuditFacade from './application/audit.facade';
import { AuditDataService } from './infrastructure/audits/audit.data.service';
import { AuditStore } from './infrastructure/audits/audit.store';
import { AuditMapper } from './infrastructure/audits/audit.mapper';
import { AsnHeaderFacade } from './application/asn-header.facade';
import { AsnHeaderDataService } from './infrastructure/asn-headers/asn-header.data.service';
import { AsnHeaderStore } from './infrastructure/asn-headers/asn-header.store';
import { AsnHeaderMapper } from './infrastructure/asn-headers/asn-header.mapper';
import { ShipmentFacade } from './application/shipment.facade';
import { ShipmentDocumentsFacade } from './application/shipment-documents.facade';
import { ShipmentDataService } from './infrastructure/shipments/shipment.data.service';
import { ShipmentStore } from './infrastructure/shipments/shipment.store';
import { ShipmentMapper } from './infrastructure/shipments/shipment.mapper';
import { AsnLineFacade } from './application/asn-line.facade';
import { AsnLineDataService } from './infrastructure/asn-lines/asn-line.data.service';
import { AsnLineStore } from './infrastructure/asn-lines/asn-line.store';
import { AsnLineMapper } from './infrastructure/asn-lines/asn-line.mapper';
import { ReceiptHeaderFacade } from './application/receipt-header.facade';
import { ReceiptHeaderDataService } from './infrastructure/receipt-headers/receipt-header.data.service';
import { ReceiptHeaderStore } from './infrastructure/receipt-headers/receipt-header.store';
import { ReceiptHeaderMapper } from './infrastructure/receipt-headers/receipt-header.mapper';
import { ReceiptLineFacade } from './application/receipt-line.facade';
import { ReceiptLineDataService } from './infrastructure/receipt-lines/receipt-line.data.service';
import { ReceiptLineStore } from './infrastructure/receipt-lines/receipt-line.store';
import { ReceiptLineMapper } from './infrastructure/receipt-lines/receipt-line.mapper';
import { RequisitionFacade } from './application/requisition.facade';
import { RequisitionDataService } from './infrastructure/requisitions/requisition.data.service';
import { RequisitionStore } from './infrastructure/requisitions/requisition.store';
import { RequisitionMapper } from './infrastructure/requisitions/requisition.mapper';
import { RequisitionLineFacade } from './application/requisition-line.facade';
import { RequisitionLineDataService } from './infrastructure/requisition-lines/requisition-line.data.service';
import { RequisitionLineStore } from './infrastructure/requisition-lines/requisition-line.store';
import { RequisitionLineMapper } from './infrastructure/requisition-lines/requisition-line.mapper';
import { ReceiptLinesDocumentsFacade } from './application/receipt-lines-documents.facade';
import { PackingListFacade } from './application/packing-list.facade';
import { PackingListDataService } from './infrastructure/packing-lists/packing-list.data.service';
import { PackingListStore } from './infrastructure/packing-lists/packing-list.store';
import { PackingListMapper } from './infrastructure/packing-lists/packing-list.mapper';
import { PackLineFacade } from './application/pack-line.facade';
import { PackLineDataService } from './infrastructure/pack-lines/pack-line.data.service';
import { PackLineStore } from './infrastructure/pack-lines/pack-line.store';
import { PackLineMapper } from './infrastructure/pack-lines/pack-line.mapper';
import { PutAwayListFacade } from './application/put-away-list.facade';
import { PutAwayListDataService } from './infrastructure/put-away-lists/put-away-list.data.service';
import { PutAwayListStore } from './infrastructure/put-away-lists/put-away-list.store';
import { PutAwayListMapper } from './infrastructure/put-away-lists/put-away-list.mapper';
import { PutAwayFacade } from './application/put-away.facade';
import { PutAwayDataService } from './infrastructure/put-away-lists/put-away.data.service';
import { PutAwayStore } from './infrastructure/put-away-lists/put-away.store';
import { PutAwayMapper } from './infrastructure/put-away-lists/put-away.mapper';
import { WarehouseItemSettingFacade } from './application/warehouse-item-setting.facade';
import { WarehouseItemSettingDataService } from './infrastructure/warehouse-item-settings/warehouse-item-setting.data.service';
import { WarehouseItemSettingStore } from './infrastructure/warehouse-item-settings/warehouse-item-setting.store';
import { WarehouseItemSettingMapper } from './infrastructure/warehouse-item-settings/warehouse-item-setting.mapper';

const wmsApiConfigFactory = (basePath: string) => {
    return (): WmsApiConfig => {
        const params: ConfigurationParameters = {
            basePath,
        };
        return new WmsApiConfig(params);
    };
};

@NgModule({
    imports: [CommonModule],
    providers: [
        WarehouseFacade,
        WarehouseDataService,
        WarehouseStore,
        WarehouseMapper,
        ZoneFacade,
        ZoneDataService,
        ZoneStore,
        ZoneMapper,
        SlotFacade,
        SlotDataService,
        SlotStore,
        SlotMapper,
        ZoneSlotService,
        ContainerFacade,
        ContainerDataService,
        ContainerStore,
        ContainerMapper,
        HandlingUnitsFacade,
        PickListFacade,
        PickListDataService,
        PickListStore,
        PickListMapper,
        PickFacade,
        PickDataService,
        PickStore,
        PickMapper,
        ProjectFacade,
        ProjectDataService,
        ProjectStore,
        ProjectMapper,
        ProjectLineItemFacade,
        ProjectLineItemDataService,
        ProjectLineItemStore,
        ProjectLineItemMapper,
        InventoryBundleFacade,
        InventoryBundleDataService,
        InventoryBundleStore,
        InventoryBundleMapper,
        ExceptionFacade,
        ExceptionDocumentsFacade,
        ExceptionDataService,
        ExceptionStore,
        ExceptionMapper,
        ExceptionTypeFacade,
        ExceptionCauseTypeFacade,
        ResolutionTypeFacade,
        WarehouseStructureService,
        InventoryAdjustmentFacade,
        InventoryAdjustmentDataService,
        InventoryAdjustmentStore,
        InventoryAdjustmentMapper,
        ReplenishmentFacade,
        ReplenishmentDataService,
        ReplenishmentStore,
        ReplenishmentMapper,
        ContainerTypeFacade,
        EquipmentTypeFacade,
        EquipmentTypeDataService,
        EquipmentTypeStore,
        EquipmentTypeMapper,
        EquipmentFacade,
        EquipmentDataService,
        EquipmentStore,
        EquipmentMapper,
        AuditFacade,
        AuditDataService,
        AuditStore,
        AuditMapper,
        AsnHeaderFacade,
        AsnHeaderDataService,
        AsnHeaderStore,
        AsnHeaderMapper,
        AsnLineFacade,
        AsnLineDataService,
        AsnLineStore,
        AsnLineMapper,
        ReceiptHeaderFacade,
        ReceiptHeaderDataService,
        ReceiptHeaderStore,
        ReceiptHeaderMapper,
        ReceiptLineFacade,
        ReceiptLineDataService,
        ReceiptLineStore,
        ReceiptLineMapper,
        ReceiptLinesDocumentsFacade,
        RequisitionFacade,
        RequisitionDataService,
        RequisitionStore,
        RequisitionMapper,
        RequisitionLineFacade,
        RequisitionLineDataService,
        RequisitionLineStore,
        RequisitionLineMapper,
        PackingListFacade,
        PackingListDataService,
        PackingListStore,
        PackingListMapper,
        PackLineFacade,
        PackLineDataService,
        PackLineStore,
        PackLineMapper,
        ShipmentFacade,
        ShipmentDocumentsFacade,
        ShipmentDataService,
        ShipmentStore,
        ShipmentMapper,
        PutAwayListFacade,
        PutAwayListDataService,
        PutAwayListStore,
        PutAwayListMapper,
        PutAwayFacade,
        PutAwayDataService,
        PutAwayStore,
        PutAwayMapper,
        WarehouseItemSettingFacade,
        WarehouseItemSettingDataService,
        WarehouseItemSettingStore,
        WarehouseItemSettingMapper,
    ],
})
export class PlatformWmsDomainModule {
    static ApiModule() {
        return WmsApiModule.forRoot(
            wmsApiConfigFactory(sharedEnv.baseApiUrl + '/wms')
        );
    }

    static ConfigProviders() {
        return [];
    }
}
